import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class LevelCompleted extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let keyboardInput = new Website.game.screens.KeyboardInput();
        keyboardInput.item.screen = this.item;
        this.item.requireProperty("keyboardInput", keyboardInput.item);

        this.item.requireProperty("game", null);
        this.item.requireProperty("backgroundEnvelope", 0);
        this.item.requireProperty("buttonEnvelope", 0);

        this.item.requireProperty("state", "active").addUpdate(this._getScopedCallFunctionCommand(this._stateChanged));
        this.item.requireProperty("fadeEnvelope", 0);

        let layer = new PIXI.Container();
        this.item.requireProperty("pixiLayer", layer);

    }

    _callback_startClicked(aEvent) {
        
        if(this.item.state === "active") {
            this.item.game.level += 1;
            this.item.game.gamePlay.controller.setupLevel();

            this.item.state = "outro";
            let animationTime = 0.6;
            this.item.properties.fadeEnvelope.animateValue(1, animationTime);
            this.item.properties.state.delayValue("outroDone", animationTime);

            this.item.levelPreviewAnimation.properties.alpha.animateValue(1, 0.2, 0.4);
            this.item.levelPreviewAnimation.properties.scale.animateValue(1.2, 0.3, 0);
            this.item.levelPreviewAnimation.properties.scale.addAdditionalAnimation(1.2, 0, 0.3, 0.3, Dbm.getRepositoryItem("easingFunctions").easeIn);
    
            this.item.levelPreviewAnimation.properties.y.animateValue(-10, 0.3, 0);
            this.item.levelPreviewAnimation.properties.y.addAdditionalAnimation(-10, 0, 0.3, 0.3, Dbm.getRepositoryItem("easingFunctions").easeIn);

            let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
            sound.play({loop: false, volume: 0.5});
    
            {
                let sound = Website.game.getTextures("sounds/interface", "zoom")[0];
                sound.play({loop: false, volume: 0.5});
            }
        }
    }

    _callback_showHighscore() {
        this.item.game.controller.showHighscoreList();

        let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
        sound.play({loop: false, volume: 0.5});
    }

    _stateChanged() {
        if(this.item.state === "outroDone") {
            this.item.game.controller.changeScreen("loadingLevel");
        }
    }

    prepare() {
        //console.log("prepare");

        {
            const box = new PIXI.Graphics();
            box.beginFill(0xefe7e1);
            box.drawRect(0, 0, Website.game.Sizes.WIDTH, Website.game.Sizes.HEIGHT);
            box.endFill();
            this.item.pixiLayer.addChild(box);
        }
        

        let background = Dbm.flow.externalObject(Website.game.getSprite("screens/background", "main"));
        background.object.anchor.set(0, 0);
        background.object.alpha = 0;
        background.addProperty("alpha", 1);
        this.item.pixiLayer.addChild(background.object);
        this.item.setValue("background", background.item);

        let map = Dbm.flow.externalObject(Website.game.getSprite("screens/map", "main"));
        map.object.anchor.set(0, 0);
        map.object.position.x = 0;
        map.addProperty("x", 0, "position.x");
        map.object.position.y = 10;
        map.object.alpha = 0;
        map.addProperty("alpha", 1);
        this.item.pixiLayer.addChild(map.object);
        this.item.setValue("map", map.item);

        let textBoxWidth = 224;

        let textBox = Dbm.flow.externalObject(new PIXI.Container());
        this.item.pixiLayer.addChild(textBox.object);
        this.item.setValue("textBox", textBox.item);

        textBox.object.position.x = Website.game.Sizes.WIDTH-textBoxWidth-10;
        textBox.object.position.y = 10+16;

        const textBoxBackground = Website.game.getButton("screens/frame", "main", 0, 7);
        textBoxBackground.width = textBoxWidth;
        this.item.setValue("textBoxBackground", textBoxBackground);
        
        
        textBox.object.addChild(textBoxBackground);
        
        {
            let text = Dbm.getRepositoryItem("game").controller.getText("...", 12, 0x000000, {wordWrap: true, wordWrapWidth: textBoxWidth-2*10, lineHeight: 18});
            this.item.setValue("text", text);
            text.position.set(10, 10);
            textBox.object.addChild(text);
            textBoxBackground.height = text.height+2*10;
        }

        let levelLine = Dbm.flow.externalObject(new PIXI.Container());
        this.item.pixiLayer.addChild(levelLine.object);
        this.item.setValue("levelLine", levelLine.item);
        this.item.pixiLayer.addChild(levelLine.object);
        

        let levelLineSprite = Website.game.getSprite("screens/level-line", "main");
        levelLineSprite.anchor.set(0, 0);
        levelLine.object.addChild(levelLineSprite);
        levelLine.object.position.x = Math.round(Website.game.Sizes.WIDTH-textBoxWidth-10+0.5*(textBoxWidth-levelLineSprite.width));
        levelLine.object.position.y = Math.round(10+textBoxBackground.height+10+16);

        let levelPreview = Dbm.flow.externalObject(new PIXI.Container());
        this.item.pixiLayer.addChild(levelPreview.object);
        this.item.setValue("levelPreview", levelPreview.item);
        this.item.pixiLayer.addChild(levelPreview.object);

        let levelPreviewAnimation = Dbm.flow.externalObject(new PIXI.Container());
        this.item.pixiLayer.addChild(levelPreviewAnimation.object);
        this.item.setValue("levelPreviewAnimation", levelPreviewAnimation.item);
        levelPreview.object.addChild(levelPreviewAnimation.object);

        levelPreviewAnimation.addProperty("y", 0, "position.y");
        levelPreviewAnimation.object.alpha = 0;
        levelPreviewAnimation.addProperty("alpha", 1);
        levelPreviewAnimation.addProperty("scale", 0);

        let levelPreviewSprite = Website.game.getSprite("screens/level-preview-bubble", "main");
        levelPreviewSprite.anchor.set(0.5, 1);
        levelPreviewAnimation.object.addChild(levelPreviewSprite);

        let levelPreviewIcon = Website.game.getSprite("screens/level-preview", "level");
        levelPreviewIcon.anchor.set(0.5, 1);
        levelPreviewIcon.position.set(0, -12);
        levelPreviewAnimation.object.addChild(levelPreviewIcon);
        this.item.setValue("levelPreviewIcon", levelPreviewIcon);

        let buttonHeight = 20;
        let buttonWidth = 120;

        {
            let startButton = new PIXI.Container();
            startButton.eventMode = "static";
            startButton.on("pointerdown", this._callback_showHighscore.bind(this));
            this.item.pixiLayer.addChild(startButton);
            this.item.setValue("highscoreButton", startButton);

            const box = Website.game.getButton("screens/button-orange");
            box.width = buttonWidth;
            box.height = buttonHeight;
            this.item.highscoreButton.addChild(box);

            this.item.highscoreButton.x = 10;
            this.item.highscoreButton.y = Website.game.Sizes.HEIGHT-buttonHeight-10;
            
            let text = Dbm.getRepositoryItem("game").controller.getText("TOPPLISTA");
            
            text.position.x = 0.5*(buttonWidth-text.width);
            text.position.y = 0.5*(buttonHeight-text.height);

            this.item.highscoreButton.addChild(text);
        }


        let startButton = new PIXI.Container();
        startButton.eventMode = "static";
        startButton.on("pointerdown", this._callback_startClicked.bind(this));
        this.item.pixiLayer.addChild(startButton);
        this.item.setValue("startButton", startButton);

        

        const box = Website.game.getButton();
        box.width = buttonWidth;
        box.height = buttonHeight;
        this.item.startButton.addChild(box);

        this.item.startButton.x = Website.game.Sizes.WIDTH-buttonWidth-10;
        this.item.startButton.y = Website.game.Sizes.HEIGHT-buttonHeight-10;
        
        let text = Dbm.getRepositoryItem("game").controller.getText("NÄSTA NIVÅ");
        
        text.position.x = 0.5*(buttonWidth-text.width);
        text.position.y = 0.5*(buttonHeight-text.height);

        this.item.startButton.addChild(text);

        let scoreDisplay = new Website.game.gameplay.graphics.ScoreDisplay();
        this.item.pixiLayer.addChild(scoreDisplay.item.pixiLayer);
        this.item.setValue("scoreDisplay", scoreDisplay.item);

        {
            let fadeLayer = new Website.game.graphics.HoleFade();
            this.item.pixiLayer.addChild(fadeLayer.item.pixiLayer);
            this.item.requireProperty("fadeLayer", fadeLayer.item);
        }

    }

    start() {

        this.item.keyboardInput.active = true;

        let texts = [
            "Svensk företagsamhet ger ett rikare samhälle.",
            "Starkare tillväxt ger mer resurser till välfärden.",
            "Svensk innovationskraft skapar nya arbetstillfällen.",
            "Svenska entreprenörer skapar nya och växande företag.",
            "Svenska uppfinningar ger nya möjligheter.",
        ];

        this.item.text.text = texts[Math.floor(Math.random()*texts.length)];
        this.item.textBoxBackground.height = this.item.text.height+2*10;
        this.item.levelLine.object.position.y = Math.round(10+this.item.textBoxBackground.height+10+16);

        this.item.buttonEnvelope = 0;
        this.item.properties.buttonEnvelope.animateValue(1, 0.8, 0.9);

        this.item.scoreDisplay.score = this.item.game.score;

        this.item.background.alpha = 0;
        this.item.background.properties.alpha.animateValue(1, 0.5, 0);

        this.item.map.alpha = 0;
        this.item.map.properties.alpha.animateValue(1, 0.5, 0);
        this.item.map.x = 0;
        this.item.map.properties.x.animateValue(10, 0.5, 0);
        
        this.item.levelPreviewAnimation.alpha = 0;
        this.item.levelPreviewAnimation.scale = 0;
        this.item.levelPreviewAnimation.y = 0;

        this.item.levelPreviewAnimation.properties.alpha.animateValue(1, 0.2, 0);
        this.item.levelPreviewAnimation.properties.scale.animateValue(1.2, 0.3, 0);
        this.item.levelPreviewAnimation.properties.scale.addAdditionalAnimation(1.2, 1, 0.3, 0.3, Dbm.getRepositoryItem("easingFunctions").easeIn);

        this.item.levelPreviewAnimation.properties.y.animateValue(-10, 0.3, 0);
        this.item.levelPreviewAnimation.properties.y.addAdditionalAnimation(-10, 0, 0.3, 0.3, Dbm.getRepositoryItem("easingFunctions").easeIn);

        let previewIndex = (this.item.game.level)%8;
        let previewTextures = Website.game.getTextures("screens/level-preview", "level");
        this.item.levelPreviewIcon.texture = previewTextures[previewIndex];

        this.item.state = "active";
        this.item.fadeEnvelope = 0;
        this.item.fadeLayer.envelope = 0;
        this.item.fadeLayer.controller.update(0, 0);

        let step = (this.item.game.level)%4;
        let levelCenterX = this.item.levelLine.object.position.x+19.5+61*step;
        let levelCenterY = this.item.levelLine.object.position.y+48-6;

        this.item.levelPreview.object.position.x = levelCenterX;
        this.item.levelPreview.object.position.y = levelCenterY;

        this.item.fadeLayer.x = levelCenterX;
        this.item.fadeLayer.y = levelCenterY;

        this.nextJumpTime = 1;
    }

    update() {

        let time = this.item.game.timer.time;
        let deltaTime = this.item.game.timer.delta;
        
        this.item.startButton.alpha = this.item.buttonEnvelope;
        this.item.highscoreButton.alpha = this.item.buttonEnvelope;

        this.item.scoreDisplay.controller.update(time, deltaTime);
        
        this.item.fadeLayer.envelope = this.item.fadeEnvelope;
        this.item.fadeLayer.controller.update(time, deltaTime);

        if(this.item.state === "active" && time > this.nextJumpTime) {
            this.item.levelPreviewAnimation.properties.y.animateValue(-5, 0.2, 0);
            this.item.levelPreviewAnimation.properties.y.addAdditionalAnimation(-5, 0, 0.2, 0.2, Dbm.getRepositoryItem("easingFunctions").easeIn);

            this.nextJumpTime += 1;
        }
    }

    stop() {
        this.item.keyboardInput.active = false;
    }

    leftInput() {
        if(!this.item.game.highscoreList.isShowing) {
            this.item.game.controller.showHighscoreList();
        }
        else {
            this.item.game.highscoreList.controller.hide();
        }
    }

    rightInput() {
        if(!this.item.game.highscoreList.isShowing) {
            this._callback_startClicked();
        }
        else {
            this.item.game.highscoreList.controller.hide();
        }
    }
}